import localStorageService from "app/services/localStorageService";

export function SetPermission({ permission, data, global }) {
  // if (global) return SetGlobalPermission({ permission, data });
  // let defaultPermissions = JSON.parse(localStorage.getItem("userPermissions"));
  // let projectPermission = {};

  // let userPermissions =
  //   projectPermission && Object.keys(projectPermission).length == 0
  //     ? defaultPermissions
  //     : projectPermission;

  // check for multiple permission

  const permissions = localStorageService.getItem("permissions");

  if (Array.isArray(permission)) {
    let flag = false;
    for (const iterator of permission) {
      if (permissions && permissions[iterator]) {
        flag = true;
        break;
      }
    }

    if (flag) {
      return data;
    } else {
      return "";
    }
  } else {
    if (permissions && permissions[permission]) {
      return data;
    } else {
      return "";
    }
  }
}

export function SetPermissionNavigation(permission, data) {
  // let projectId = localStorage.getItem("projectId")
  // let manageProjectPermissions = JSON.parse(localStorage.getItem("manageProjectPermissions"))
  // let defaultPermissions = JSON.parse(localStorage.getItem("userPermissions"));
  // let projectPermission = {};
  // if (projectId !== null && manageProjectPermissions !== null && Array.isArray(manageProjectPermissions) && manageProjectPermissions.length > 0) {
  //     Array.isArray(manageProjectPermissions) && manageProjectPermissions.map((permissionData) => {
  //         if (parseInt(projectId) === parseInt(permissionData.projectId)) {
  //             projectPermission = JSON.parse(permissionData.managePermissions)
  //         }
  //     })
  // }
  // let userPermissions =
  //   projectPermission && Object.keys(projectPermission).length == 0
  //     ? defaultPermissions
  //     : projectPermission;
  const permissions = localStorageService.getItem("permissions");

  if (permissions[permission]) {
    return data;
  } else {
    return true;
  }
}

export function SetPermissionNavigationSubModule(permission) {
  // let projectId = localStorage.getItem("projectId")
  // let manageProjectPermissions = JSON.parse(localStorage.getItem("manageProjectPermissions"));
  // let defaultPermissions = JSON.parse(localStorage.getItem("userPermissions"));
  // let projectPermission = {};
  // if (projectId !== null && manageProjectPermissions !== null && Array.isArray(manageProjectPermissions) && manageProjectPermissions.length > 0) {
  //     Array.isArray(manageProjectPermissions) && manageProjectPermissions.map((permissionData) => {
  //         if (parseInt(projectId) === parseInt(permissionData.projectId)) {
  //             projectPermission = JSON.parse(permissionData.managePermissions)
  //         }
  //     })
  // }
  // let userPermissions =
  //   projectPermission && Object.keys(projectPermission).length == 0
  //     ? defaultPermissions
  //     : projectPermission;
  const permissions = localStorageService.getItem("permissions");

  if (permissions && permissions[permission]) {
    return true;
  } else {
    return false;
  }
}

export function SetPermissionGlobalNavigationSubModule(permission) {
  // let globalPermissions = JSON.parse(localStorage.getItem("globalPermissions"));
  const permissions = localStorageService.getItem("permissions");

  if (permissions && permissions[permission]) {
    return true;
  } else {
    return false;
  }
}

export function SetGlobalPermission({ permission, data }) {
  //  check for superAdmin in userPermission
  const permissions = localStorageService.getItem("permissions");

  if (permission === "superAdmin") {
    // let userPermissions = JSON.parse(localStorage.getItem("userPermissions"));

    if (permissions && permissions[permission]) {
      return data;
    } else {
      return "";
    }
  }

  // globalPermission
  // let globalPermissions = JSON.parse(localStorage.getItem("globalPermissions"));

  // check for multiple permission
  if (Array.isArray(permission)) {
    let flag = false;
    for (const iterator of permission) {
      if (permissions && permissions[iterator]) {
        flag = true;
        break;
      }
    }

    if (flag) {
      return data;
    } else {
      return "";
    }
  } else {
    if (permissions && permissions[permission]) {
      return data;
    } else {
      return "";
    }
  }
}

export const isPermissions = (permissionsType) => {
  const permissions = localStorageService.getItem("permissions");
  return permissions[permissionsType];
};
